import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import ChevronUi from './Chevron';
export var Root = styled.li.withConfig({
  displayName: "ui-kit-Root",
  componentId: "ui-kit-1e8lqpi"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 10px 16px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  text-decoration: none;\n  text-align: left;\n  outline: none;\n  background-color: transparent;\n  -webkit-tap-highlight-color: transparent;\n  color: ", ";\n  /* Body14/Regular */\n  font-size: 14px;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  line-height: 20px;\n  letter-spacing: -0.004em;\n  \n  &.disabled {\n    color: ", ";\n  }\n\n  &.leftIcon, &.rightIcon {\n    padding-top: 8px;\n    padding-bottom: 8px;\n  }\n\n  &.rightIcon {\n    padding-right: 12px;\n  }\n\n  &.submenu {\n    padding-right: 24px;\n  }\n"], ["\n  margin: 0;\n  padding: 10px 16px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  text-decoration: none;\n  text-align: left;\n  outline: none;\n  background-color: transparent;\n  -webkit-tap-highlight-color: transparent;\n  color: ", ";\n  /* Body14/Regular */\n  font-size: 14px;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  line-height: 20px;\n  letter-spacing: -0.004em;\n  \n  &.disabled {\n    color: ", ";\n  }\n\n  &.leftIcon, &.rightIcon {\n    padding-top: 8px;\n    padding-bottom: 8px;\n  }\n\n  &.rightIcon {\n    padding-right: 12px;\n  }\n\n  &.submenu {\n    padding-right: 24px;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.label.primary;
}, function (_a) {
  var theme = _a.theme;
  return theme.fontFamily;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.inactive;
});
export var Icon = styled.span.withConfig({
  displayName: "ui-kit-Icon",
  componentId: "ui-kit-1g3eevk"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n\n  ", ".disabled & {\n    color: inherit;\n  }\n\n  & > svg {\n    vertical-align: middle;\n    color: inherit;\n  }\n"], ["\n  color: ", ";\n\n  "
/* sc-sel */
, ".disabled & {\n    color: inherit;\n  }\n\n  & > svg {\n    vertical-align: middle;\n    color: inherit;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.label.secondary;
},
/* sc-sel */
Root);
export var LeftIcon = styled(Icon).withConfig({
  displayName: "ui-kit-LeftIcon",
  componentId: "ui-kit-1uunk7v"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-right: 12px;\n"], ["\n  margin-right: 12px;\n"])));
export var RightIcon = styled(Icon).withConfig({
  displayName: "ui-kit-RightIcon",
  componentId: "ui-kit-1r707au"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-left: 8px;\n"], ["\n  margin-left: 8px;\n"])));
export var Chevron = styled(ChevronUi).withConfig({
  displayName: "ui-kit-Chevron",
  componentId: "ui-kit-1u8sqb4"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: 0 4px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  color: ", ";\n\n  ", ".disabled & {\n    color: inherit;\n  }\n"], ["\n  margin: 0 4px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  color: ", ";\n\n  "
/* sc-sel */
, ".disabled & {\n    color: inherit;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.label.tertiary;
},
/* sc-sel */
Root);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;